export const serviceWorkerRegister = () => {
    navigator.serviceWorker.register('./sw.js').then(() => {
        console.log('SW successfully registered');
    }).catch((error) => {
        console.error('error: ', error);
    });
};
